export function useShowInterviewMonitoringUi(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.get('showMonitoring') === 'true';
}
